"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssoSmp = exports.getLayout = void 0;
const template_1 = require("./template");
const ssoSmp = __importStar(require("./layout/ssoSmp"));
exports.ssoSmp = ssoSmp;
const nrc_1 = require("./layout/nrc");
const sccarr_1 = require("./layout/sccarr");
const abcdeFnsp_1 = require("./layout/abcdeFnsp");
const abcdeTemp85Patch_1 = require("./layout/abcdeTemp85Patch");
const medical_1 = require("./layout/medical");
const ircs_1 = require("./layout/fiche/ircs");
const procesVerbal_1 = require("./layout/fiche/procesVerbal");
const refusTransportSoins_1 = require("./layout/fiche/refusTransportSoins");
const collision_1 = require("./layout/fiche/collision");
const regards_1 = require("./layout/regards");
/**
 * Permet de récupérer la mise en forme souhaité
 * @param {SyoLib.TemplateType} template Indicateur du layout souhaité
 * @param elem
 * @return {SyoLib.TemplatePart}
 */
const getLayout = (template, elem) => {
    let tempLayout = [];
    switch (template) {
        // BILAN MÉDICAUX
        case 'NRC':
            tempLayout = (0, nrc_1.makeNrcLike)();
            break;
        case 'SCCARR':
            tempLayout = (0, sccarr_1.makeSccarrLike)();
            break;
        case 'ABCDE':
            tempLayout = (0, abcdeFnsp_1.makeAbcdeLike)();
            break;
        case 'XABCDE':
            tempLayout = (0, abcdeFnsp_1.makeXabcdeLike)();
            break;
        case 'XABCDE_TEMP_85_PATCH':
            tempLayout = (0, abcdeTemp85Patch_1.makeXabcdeTemp85PatchLike)();
            break;
        case 'MARCHE':
            tempLayout = (0, abcdeFnsp_1.makeXabcdeLike)(['M', 'A', 'R', 'C', 'H', 'E']);
            break;
        case 'REGARDS':
            tempLayout = (0, regards_1.makeRegardsLike)();
            break;
        case 'MEDICAL_V1':
            tempLayout = (0, medical_1.makeMedicalLike)();
            break;
        case 'MEDICAL_V2':
            tempLayout = (0, medical_1.makeMedicalLikeV2)();
            break;
        // SSO SMP
        case 'SSO_EXAMEN':
            tempLayout = ssoSmp.makesSsoSmpExamenSso(`${elem?.nom ? elem.nom : 'NR'} ${elem?.prenom ? elem.prenom : ''} (Passage${elem.bilans.length > 1 ? 's' : ''}: ${elem.bilans.length})`, elem?.bilans?.length || 0);
            break;
        case 'SMP_EXAMEN':
            tempLayout = ssoSmp.makesSsoSmpExamenSmp(`${elem?.nom ? elem.nom : 'NR'} ${elem?.prenom ? elem.prenom : ''} (Passage${elem.bilans.length > 1 ? 's' : ''}: ${elem.bilans.length})`, elem?.bilans?.length || 0);
            break;
        case 'SSO_EXAMEN_BILAN':
            tempLayout = ssoSmp.makesSsoSmpExamenBilanSso();
            break;
        case 'SMP_EXAMEN_BILAN':
            tempLayout = ssoSmp.makesSsoSmpExamenBilanSmp();
            break;
        case 'SSO_CONTEXT_PERSON_IN_PLACE':
            tempLayout = ssoSmp.makesSsoSmpContextPersonInPlace();
            break;
        case 'SSO_CONTEXT_CONTACT_MAD':
            tempLayout = ssoSmp.makesSsoSmpContextContactMad();
            break;
        case 'SSO_CONTEXT_ACTION_SYNTHESE':
            tempLayout = ssoSmp.makesSsoSmpContextActionSynthese();
            break;
        // TABLEAU
        case 'GESTE_VVP':
            tempLayout = (0, template_1.makeGesteExcelVvp)();
            break;
        case 'OBSTETRIQUE_APGAR':
            tempLayout = (0, template_1.makeObstetriqueApgarExcel)();
            break;
        case 'GESTE_SYNTHESE_EVOLUTION':
            tempLayout = (0, template_1.makeGesteExcelSyntheseEvolution)();
            break;
        case 'EQUIPAGE':
            tempLayout = (0, template_1.makeExcelEquipes)();
            break;
        case 'TEMOINS':
            tempLayout = (0, template_1.makeExcelTemoins)();
            break;
        // FICHES
        case 'IRCS_SHEET':
            tempLayout = (0, ircs_1.makeIrcsSheet)();
            break;
        case 'PROCES_VERBAL_SHEET':
            tempLayout = (0, procesVerbal_1.makeProcesVerbalSheet)();
            break;
        case 'REFUS_TRANSPORT_SOINS_SHEET':
            tempLayout = (0, refusTransportSoins_1.makeRefusTransportSoinsSheet)();
            break;
        case 'COLLISION_SHEET':
            tempLayout = (0, collision_1.makeCollisionSheet)();
            break;
        case 'COLLISION_SHEET_TEMOINS':
            tempLayout = (0, template_1.makeCollisionSheetTemoins)();
            break;
        case 'COLLISION_SHEET_TIERS':
            tempLayout = (0, template_1.makeCollisionSheetTiers)();
            break;
        case 'COLLISION_SHEET_IMPLIQUES':
            tempLayout = (0, template_1.makeCollisionSheetImpliques)();
            break;
        default:
            tempLayout = [];
            break;
    }
    return tempLayout;
};
exports.getLayout = getLayout;
